export default __webpack_public_path__ + "static/media/desinged-for.605bc8b5.png";